import { motion } from "framer-motion";
import { Shield, Monitor, Code, Star, Laptop, Users } from "lucide-react";
import SidebarGalleryPage from "../Main/Sidebargallery";

const dcimInfo = {
  intro:
    "The Digital Citizenship & Internet Maturity Club has been started at the Govt. Women's Polytechnic College with support from Nature Ed-Tech to address the following objectives:",
  objectives: [
    { title: "Ensuring students' online safety and well-being", icon: Shield },
    { title: "Promoting digital discipline in the college", icon: Monitor },
    { title: "Building technical skills", icon: Code },
    { title: "Enhancement of college's online reputation", icon: Star },
    { title: "Excellence in online education processes", icon: Laptop },
    { title: "Development of DCIM skills among students", icon: Users },
  ],
  additionalInfo:
    "The founding student members of the club are Ku. Priya Patel, Ku. Priya Rathore, Ku. Priya Singh, Ku. Priyanka Patel, Ku. Radha Yadav, Sushri Rishi Patel, and Vidhi Rai. The club members will conduct critical activities under the supervision of Dr. Shailendra Sharma in line with the DCIM Curriculum created by Nature Ed-Tech.",
};

export default function DCIMClubSection() {
  return (
    <div className="min-h-screen bg-gray-100 p-14">
      {/* Main Container */}
      <div className="max-w-7xl mx-auto ">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="border-4 border-teal-500 p-2 rounded-lg">
                <h2 className="text-3xl p-2 font-bold text-white bg-teal-500 rounded-sm">
                  Digital Citizenship & Internet Maturity Club
                </h2>
                <motion.p
                  className="text-gray-700 leading-relaxed p-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  {dcimInfo.intro}
                </motion.p>
                <div className="space-y-6 p-4">
                  {dcimInfo.objectives.map((objective, index) => (
                    <motion.div
                      key={index}
                      className="flex items-center gap-4"
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.3 + index * 0.1 }}
                    >
                      <objective.icon className="w-8 h-8 text-teal-500" />
                      <span className="text-gray-700 text-lg">{objective.title}</span>
                    </motion.div>
                  ))}
                </div>
                <motion.p
                  className="text-gray-600 bg-gray-200 p-4 rounded-lg shadow"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.8 }}
                >
                  {dcimInfo.additionalInfo}
                </motion.p>
            </div>
          </motion.div>

          {/* Sidebar - Gallery */}
          <SidebarGalleryPage />
        </div>
      </div>
    </div>
  );
}
